import React, { useEffect } from "react";
import "../../Style/PurposeSection.css";
import purposeData from "../../Json/PurposeData.json";
import { myCustomTheme } from "../../Theme";
import { useNavigate } from "react-router-dom";
import OurSectionImg from "../../Assets/Our-Section.jpg";

const PurposeSection = ({ imageBottom = false }) => {
    const theme = myCustomTheme;

    // ✅ Image mapping system
    const images = {
        ourSection: OurSectionImg,
    };

    const navigate = useNavigate();

    // ✅ OPEN ANIMATION ONLY
    useEffect(() => {
        const section = document.querySelector(".purpose-section");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            { threshold: 0.2 }
        );

        if (section) {
            observer.observe(section);
        }

        return () => {
            if (section) {
                observer.unobserve(section);
            }
        };
    }, []);

    return (
        <section
            className="purpose-section"
            style={{
                background: theme.colors.bg_primary,
                fontFamily: theme.typography.text_font,
            }}
        >
            <div
    className={`purpose-container ${imageBottom ? "image-bottom-layout" : ""}`}
    style={{
        maxWidth: theme.spacing.container_max,
    }}
>
                {/* IMAGE */}
                <div
                    className="purpose-image-wrapper"
                    style={{
                        boxShadow: theme.shadows.soft,
                    }}
                >
                    <img
                        src={images[purposeData.imageKey]}
                        alt="purpose"
                        className="purpose-image"
                        width={"100%"}
                    />
                </div>

                {/* CONTENT */}
                <div className="purpose-content">

                    {/* LEFT */}
                    <div className="purpose-left">

                        <span
                            className="purpose-subtitle"
                            style={{
                                color: theme.colors.menu_text,
                            }}
                        >
                            {purposeData.subTitle}
                        </span>

                        <h1
                            className="purpose-heading"
                            style={{
                                color: theme.colors.heading,
                                fontFamily: theme.typography.heading_font,
                            }}
                        >
                            {purposeData.heading}
                        </h1>

                        {/* ✅ ADDED CENTER PARAGRAPH */}
                        <p
                            className="purpose-center-text"
                            style={{ color: theme.colors.menu_text }}
                        >
                            We focus on delivering meaningful value through design,
                            creativity, and innovation to help you achieve your goals.
                        </p>

                        <button
                            className="purpose-btn"
                            style={{
                                background: theme.colors.button_bg,
                                color: theme.colors.button_text,
                                boxShadow: theme.shadows.soft,
                            }}
                            onClick={() => navigate("/about")}
                        >
                            {purposeData.buttonText}
                        </button>

                    </div>

                    {/* RIGHT (DYNAMIC ACCORDIONS) */}
                    <div className="purpose-right">

                        {purposeData.accordions.map((item, index) => (
                            <div
                                key={index}
                                className="purpose-accordion"
                                style={{
                                    background: "#f7f7f7",
                                    border: `1px solid ${theme.colors.icon_border}`,
                                    boxShadow: theme.shadows.neumorphic,
                                }}
                            >
                                <div className="accordion-left">
                                    <span
                                        className="accordion-static"
                                        style={{ color: theme.colors.heading }}
                                    >
                                        {item.title}
                                    </span>
                                </div>

                                <p
                                    className="accordion-text"
                                    style={{ color: theme.colors.menu_text }}
                                >
                                    {item.text}
                                </p>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </section>
    );
};

export default PurposeSection;